import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() pageSize = 25;
  @Input() totalPages = 1;
  @Input() totalCount = 0;
  @Input() page = 1;
  @Input() link: string | string[] | false = undefined;
  @Input() window = 4;
  @Output() pageChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  getInfo(page: number) {
    const from = this.totalCount > 0 ? (page - 1) * this.pageSize + 1 : 0;
    const to = Math.min(page * this.pageSize, this.totalCount);
    return `${ from } - ${ to } of ${ this.totalCount }`;
  }
}
